import { GzSelectMenuWithButtonWebComponent } from './component/GzSelectMenuWithButtonWebComponent';

export { GzSelectMenuWithButtonWebComponent };
